import { render, staticRenderFns } from "./AdminSteamItemPriceRule.vue?vue&type=template&id=3cd35cfe&scoped=true&"
import script from "./AdminSteamItemPriceRule.vue?vue&type=script&lang=ts&"
export * from "./AdminSteamItemPriceRule.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSteamItemPriceRule.vue?vue&type=style&index=0&id=3cd35cfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd35cfe",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QDialog,QCard,QCardSection,QSpace,QScrollArea,QForm,QSelect,QToggle,QInput});qInstall(component, 'directives', {ClosePopup});
